import React, { useState, useMemo, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WORKSITEALL, COMPANY, PROJECT, WORKSITE } from "../../services/actions";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";

import { Container, Box, Grid, Pagination, Button, Card, Chip } from "@mui/material";
import ActionBar from "../extra/ActionBar";

import Timeline from "./Timeline";
import SiteForm from "./SiteForm";
import { BsFillPencilFill } from "react-icons/bs";
import "./timeline.css";

export default function View() {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { from_project } = location.state || {};
  const [project, setProject] = React.useState({});
  const [company, setCompany] = React.useState(0);
  const [projects, setProjects] = React.useState([]);
  let projectState = useSelector((state) => state?.projectState);
  let companyState = useSelector((state) => state?.companyState);
  let worksiteallState = useSelector((state) => state?.worksiteallState);
  let user = useSelector((state) => state?.loginState?.auth);
  const [days, setDays] = React.useState({})
  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});

  React.useEffect(() => {
    try {
      dispatch({ type: `${COMPANY}_GET`, payload: 0 });
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    setProjects(projectState?.data?.results || [])
  }, [projectState?.data?.results])

  const fetchProgress = (id = 0) => {
    const url = `worksites/0/?filter_by={"project_id":"${id}"}`
    dispatch({ type: `${WORKSITEALL}_GET`, payload: url });
  };

  const onChange = (value) => {
    setProjects([])
    if (value) {
      setCompany(value)
      dispatch({
        type: `${PROJECT}_GET`,
        payload: `project/0/?filter_by={"company":"${value}"}`,
      });
    }
  }

  const onProject = (value) => {
    if (!value) return
    let prjs = projectState?.data?.results.filter((p) => p.id == value)
    if (prjs?.[0]?.id) {
      setProject(prjs[0])
      fetchProgress(prjs[0]?.id)
      const se = findStartEndDate(prjs[0])
      setDays(se)

    }
  }

  React.useEffect(() => {
    if (from_project?.id) {
      setProject(from_project)
      fetchProgress(from_project?.id)
      setDays(findStartEndDate(from_project))
      setCompany(from_project.company)
    }
  }, [from_project?.id])

  const formatdate = (date) => date?.split("T")[0]

  const findStartEndDate = (project, day = 0, page = 14) => {
    if (!project) return {}
    const start = new Date(project.start_project_date);
    start.setDate(start.getDate() + day)
    const monthEnd = new Date(project.start_project_date)
    monthEnd.setDate(monthEnd.getDate() + (page + day))
    let startDate = start.toISOString()
    let endDate = monthEnd.toISOString()
    const sd = formatdate(startDate)
    const ed = formatdate(endDate)
    return {
      startDate: startDate, endDate: endDate,
      formattedStartDate: sd,
      formattedEndDate: ed,
    }
  }
  const timelines = useMemo(() => {
    return generateDays(days.formattedStartDate, days.formattedEndDate);
  }, [days.formattedStartDate, days.formattedEndDate]);
  function generateDays(start, end) {
    const s = dayjs(start);
    const e = dayjs(end);
    const diff = e.diff(s, "day") + 1;

    return Array.from({ length: diff }, (_, i) =>
      s.add(i, "day").format("YYYY-MM-DD")
    );
  }
  const onProgressClick = (item) => {
    if (project?.id) {
      if (item?.deadline) {
        item.deadline = formatdate(item.deadline)
      }
      navigate("/edit_progress/", {
        state: {
          project: project,
          progress: item,
        },
      });
    }
  }
  const memoProject = React.useMemo(() => project, [project]);

  let heads = [1, 2, 3].map((i) => <h1>hello={1}</h1>)

  return (
    <>
      {open ? <SiteForm
        defaultValues={defV}
        onSubmit={(data) => {
          data.project = project?.id
          let ACTION = data.id ? `${WORKSITE}_PATCH` : `${WORKSITE}_POST`;
          dispatch({ type: ACTION, payload: data });
        }}

        back={() => {
          onProject(project?.id)
          setOpen(false);
        }}
      /> :
        <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            hasPermission={user?.permissions?.includes("work_progs.add_workprogress")}
            label="Task & Progress"
            btnLabel={"ADD SITES & TASKS"}
            setOpen={(s) => {
              if (project?.id) {
                navigate("/sites/", {
                  state: {
                    project: project,
                  },
                });
              }
            }}
          />

          <Box sx={{ display: 'flex', py: 3, gap: 2 }}>
            <select onChange={(e) => onChange(e.target.value)} value={company}>
              <option value="0" >Select Company</option>
              {companyState?.data?.results?.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.company_name}
                </option>
              ))}
            </select>

            <select onChange={(e) => onProject(e.target.value)} value={project?.id}>
              <option value="0">Select Project</option>
              {projects?.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.project_name}
                </option>
              ))}
            </select>
          </Box>
          <Box>
            <Box className="input-label" display={'flex'} justifyContent={'space-between'}>
              <Box>Project Start {formatdate(project?.start_project_date)}</Box>
              <Box> {days.formattedEndDate}</Box>
              <Box>Project End {formatdate(project?.end_project_date)}</Box>
            </Box>
            <input {...{ disabled: !project?.duration }} type="range" min="0" step={1} max={Number(project?.duration || 7)} onChange={(e) => {
              const v = Number(e.target.value);
              setDays(findStartEndDate(project, v))
            }
            } class="slider" />
          </Box>
          <Box sx={{ overflowX: 'auto', maxHeight: '55vh' }}>
            <Card sx={{ p: 2 }}>
              <h2 className="input-label">{project?.project_name && `Timeline of  ${project?.project_name}`}</h2>
              <table className="timeline-table" style={{ borderRadius: 5 }}>
                <tbody>
                  <tr className="input-label">
                    <th width={200}>
                      <div style={{ padding: 5, display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                        <label>Sites</label>
                        {project?.id && <Chip onClick={() => { setOpen(true); setDefV({}) }} sx={{ cursor: 'pointer', fontSize: 10 }} size="small" label="Add new site" color="success" />}
                      </div>
                    </th>
                    <th>Tasks</th>
                  </tr>

                  {worksiteallState.data?.results.map((work) => {
                    return <>
                      <tr>
                        <td width={60} className="input-label">
                          <div style={{ padding: 5, display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                            {work.site_name} <BsFillPencilFill onClick={() => { setDefV(work); setOpen(true) }} />
                          </div>
                        </td>
                        <td className="input-label">

                          {work?.tasks?.length == 0 ?
                            <>
                              <Box textAlign={"left"}>
                                {project?.id && (
                                  <Chip
                                    sx={{ cursor: "pointer", fontSize: 10 }}
                                    size="small"
                                    label="Add new task"
                                    color="success"
                                    onClick={() => onProgressClick({ worksite: work.id })}
                                  />
                                )}
                              </Box>

                              No task added
                            </>
                            :
                            <div>
                              <table className="timeline-table">
                                <thead>
                                  <tr className="input-label">
                                    <th style={{ width: "120px" }}>
                                      Tasks
                                      {/* ({dayjs(days.formattedStartDate).format("YYYY")}-
                                    {dayjs(days.formattedEndDate).format("YYYY")}) */}
                                    </th>
                                    {timelines.map((d, i) => <th key={i}>{dayjs(d).format("DD MMM")}</th>)}

                                  </tr>
                                </thead>
                                <tbody>
                                  {(work?.tasks || [])?.map((item) => (
                                    <Timeline
                                      key={item.id}
                                      item={item}
                                      days={timelines}
                                      timelineStart={days.formattedStartDate}
                                      onProgressClick={onProgressClick}
                                      project={project}
                                    />
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          }
                        </td>
                      </tr>
                    </>
                  })}

                </tbody>
              </table>
            </Card>
          </Box>
        </Container>
      }
    </>
  );
}
